export default __webpack_public_path__ + "static/media/cassette.339c67ff.png";